var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "提示",
        visible: _vm.dialogVisible,
        width: "30%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "y-f" }, [
          _c("i", { staticClass: "el-icon-info systemColor y-fs-16 y-mr-5" }),
          _c("div", [
            _vm._v("接电商平台通知，小红书平台自"),
            _c("span", { staticClass: "y-fc-F32F52" }, [_vm._v("2月25号")]),
            _vm._v("起只能使用"),
            _c("span", { staticClass: "y-fc-F32F52" }, [
              _vm._v("新小红书电子面单"),
            ]),
            _vm._v("打单发货，请您尽快切换。"),
          ]),
        ]),
        _c("div", { staticClass: "y-mt-10 y-ml-20 y-fs-14" }, [
          _vm._v("为了避免打印异常，"),
          _c("span", { staticClass: "y-fc-F32F52" }, [
            _vm._v("请勿混合使用新老电子面单"),
          ]),
          _vm._v("。"),
        ]),
        _c(
          "div",
          { staticClass: "y-mt-20 y-ml-20" },
          [
            _c("el-checkbox", {
              model: {
                value: _vm.checked,
                callback: function ($$v) {
                  _vm.checked = $$v
                },
                expression: "checked",
              },
            }),
            _c(
              "span",
              {
                staticClass: "y-ml-5 y-c-p",
                on: {
                  click: function ($event) {
                    _vm.checked = !_vm.checked
                  },
                },
              },
              [_vm._v("我知道了，下次不再提醒")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("确定")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.openUrlFn } },
            [_vm._v("查看教程")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }